import { render, staticRenderFns } from "./cgggxx.vue?vue&type=template&id=2c89fbba&scoped=true"
import script from "./cgggxx.vue?vue&type=script&lang=js"
export * from "./cgggxx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c89fbba",
  null
  
)

export default component.exports